import Modal from "../../common/Modal";
import styles from './NewCakeOrderNotification.module.css';


export default function NewCakeOrderNotification({ newOrders, setShowModal }) {
    function handleClose() {
        setShowModal(false);
    }

    return (
       <Modal onClose={handleClose} >
            <div className={styles['notif-title']}>🎂 Pasteles Para Hoy 🎂</div>
            {newOrders.map((order) => (
                <div key={order.id} className={styles['new-order-notification']}>
                       <p className={styles['customer-name']}>{order.firstName} {order.lastName}</p>
                       <p className={styles['cake-detail']}>Hora: {order.time}</p>
                       <p className={styles['cake-detail']}>Tamaño: {order.cakeSize}</p>
                    <div className={styles['cake-tag-container']}>
                        {order.filling1 && (
                            <div className={styles['cake-tag']}>Relleno 1: {order.filling1}</div>
                        )}
                        {order.filling2 && (
                            <div className={styles['cake-tag']}>Relleno 2: {order.filling2}</div>
                        )}
                        {order.message && (
                            <div className={styles['cake-tag']}>Inscripción: {order.message}</div>
                        )}
                    </div>
                </div>
            ))}
       </Modal>
    );
}
